export default __webpack_public_path__ + "static/bg-what-is-ml-9b03da50b06521d9c54482c6a32d1d6f.jpg";